import { writable } from 'svelte/store';
import { browser } from '$app/environment';

function createThemeStore() {
  const { subscribe, set } = writable<'light' | 'dark'>('light');

  if (browser) {
    // Initialize theme based on system preference
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    set(darkModeMediaQuery.matches ? 'dark' : 'light');

    // Listen for system theme changes
    darkModeMediaQuery.addEventListener('change', (e) => {
      set(e.matches ? 'dark' : 'light');
    });
  }

  return {
    subscribe,
    set
  };
}

export const theme = createThemeStore(); 